module.exports = __webpack_public_path__ + "static/media/successShield.bcd882c1.svg";